export default {
  standings: {
    title: "Classifiche",
    empty: {
      unavailable: "Classifiche non disponibili al momento.",
    },
    labels: {
      ranking: "#",
      team: "Squadra",
    },
    columns: {
      GP: "GP",
      W: "W",
      L: "L",
      T: "T",
      OTL: "OTL",
      PTS: "PTS",
      PCT: "PCT",
      D: "D",
    },
    picker: {
      conference: "Conference",
      division: "Division",
      overall: "Complessivo",
    },
    sections: {
      conference: "Conference",
      division: "Division",
      overall: "Complessivo",
    },
  },
};